import {Config} from '@/config';

class ForumApi {
  public buildForumUrl(path: string) {
    return `${Config.forumUrl}${path}`;
  }

  public getUserProfileUrl(userId: number) {
    return this.buildForumUrl(`/member.php?u=${userId}`);
  }

  public getForumThreadUrl(threadId: number) {
    return this.buildForumUrl(`/showthread.php?t=${threadId}`);
  }

  public getForumPostUrl(postId: number) {
    return this.buildForumUrl(`/showpost.php?p=${postId}`);
  }
}

export const forumApi = new ForumApi();
